export const DASHBOARD_USAGE_ROUTE = {
	name: 'dashboard-usage',
	route(): string[] {
		return ['/', this.name];
	},
	DEFAULT: '',
	SCHOOL_USAGE: {
		name: 'school/:schoolId',
		route(schoolId: string): string[] {
			return [...DASHBOARD_USAGE_ROUTE.route(), 'school', schoolId];
		}
	},
	DISTRICT_USAGE: {
		name: 'district/:boardId',
		route(boardId: string): string[] {
			return [...DASHBOARD_USAGE_ROUTE.route(), 'district', boardId];
		}
	},
	REGION_USAGE: {
		name: 'region/:regionId',
		route(regionId: string): string[] {
			return [...DASHBOARD_USAGE_ROUTE.route(), 'region', regionId];
		}
	}
};
